import React from "react";
import { Button, Grid, TextField } from "@mui/material";
import Abhaicons from "../../Images/Adharicon.svg";
import Abhashiled from "../../Images/material-symbols-light_shield-outline.svg";
import { validateAadhaar } from "../../../helpers/commonHelper";

const Step1AadhaarInput = ({
  aadhaar,
  setAadhaar,
  consentChecked,
  setConsentChecked,
  userName,
  onNext,
}) => {

  // Format Aadhaar with hyphens (XXXX-XXXX-XXXX)
  const handleAadhaarChange = (e) => {
    let value = e.target.value.replace(/\D/g, ""); // Remove non-digits
    if (value.length > 12) value = value.slice(0, 12);

    // Add hyphens
    if (value.length > 8) {
      value = value.slice(0, 4) + "-" + value.slice(4, 8) + "-" + value.slice(8);
    } else if (value.length > 4) {
      value = value.slice(0, 4) + "-" + value.slice(4);
    }

    setAadhaar(value);
  };

  // Get clean Aadhaar number (without hyphens)
  const cleanAadhaar = aadhaar.replace(/\D/g, "");

  // Validation using Verhoeff Algorithm
  const isAadhaarValid = cleanAadhaar.length === 12 && validateAadhaar(aadhaar);
  const isStep1Valid = isAadhaarValid && consentChecked;

  // Helper text for validation
  const getHelperText = () => {
    if (aadhaar.length === 0) return "";

    if (cleanAadhaar.length < 12) {
      return "Please enter a valid 12-digit Aadhaar number";
    }

    if (!validateAadhaar(aadhaar)) {
      return "Invalid Aadhaar number";
    }

    return "";
  };

  return (
    <div className="text-center">
      <img src={Abhaicons} alt="ABHA Icon" />
      <h5 className="sub-text">Create ABHA</h5>
      <p className="sub-para">
        Register a new beneficiary with ABHA. All beneficiaries must have a valid ABHA.
      </p>

      <Grid container spacing={4} className="mt-2">
        {/* Aadhaar Number Input */}
        <Grid size={{ xs: 12, md: 12 }}>
          <TextField
            label={
              <>
                Aadhaar Number <span className="txtRed">*</span>
              </>
            }
            variant="outlined"
            fullWidth
            size="small"
            value={aadhaar}
            onChange={handleAadhaarChange}
            placeholder="XXXX-XXXX-XXXX"
            inputProps={{
              maxLength: 14,
              inputMode: "numeric",
            }}
            error={aadhaar.length > 0 && !isAadhaarValid}
            helperText={getHelperText()}
          />
        </Grid>

        {/* Consent Checkbox */}
        <Grid size={12} className="text-start">
          <div className="consent-container">
            <div className="consent-box">
              <label className="consent-checkbox-label">
                <input
                  type="checkbox"
                  checked={consentChecked}
                  onChange={(e) => setConsentChecked(e.target.checked)}
                  className="consent-checkbox"
                />
                <span className="consent-checkbox-text">I hereby declare that:</span>
              </label>

              <ul>
                <li>
                  I am voluntarily sharing my Aadhaar Number / Virtual ID issued by the Unique Identification Authority of India ("UIDAI"), and my demographic information for
                  the purpose of creating an Ayushman Bharat Health Account number ("ABHA number") and Ayushman Bharat Health Account address ("ABHA Address").
                  I authorize NHA to use my Aadhaar number / Virtual ID for performing Aadhaar based authentication with UIDAI as per the provisions of the
                  Aadhaar (Targeted Delivery of Financial and other Subsidies, Benefits and Services) Act, 2016 for the aforesaid purpose.
                  I understand that UIDAI will share my e-KYC details, or response of "Yes" with NHA upon successful authentication.
                </li>
                <li>
                  I consent to usage of my ABHA address and ABHA number for linking of my legacy (past) government health records and those which will
                  be generated during this encounter.
                </li>
                <li>
                  I authorize the sharing of all my health records with healthcare provider(s) for the purpose of providing
                  healthcare services to me during this encounter.
                </li>
                <li>
                  I consent to the anonymization and subsequent use of my government health records for public
                  health purposes.
                </li>
                <li>
                  I, healthcare worker with username <b>{userName}</b>, confirm that I have duly informed and explained the beneficiary of the contents
                  of consent for aforementioned purposes.
                </li>
                <li>
                  I have been explained about the consent as stated above and hereby provide my consent for the aforementioned
                  purposes.
                </li>
              </ul>
            </div>
          </div>
        </Grid>
      </Grid>

      <Button
        className={`send-otp-btn ${isStep1Valid ? "active" : ""}`}
        variant="contained"
        fullWidth
        disabled={!isStep1Valid}
        onClick={onNext}
        sx={{ mt: 2 }}
      >
        Send OTP
      </Button>

      <div className="para-ofadhar">
        <span>
          <img src={Abhashiled} alt="Shield" />
        </span>
        <p>
          Your Aadhaar details are secure and encrypted. OTP will be sent to
          your registered mobile number.
        </p>
      </div>
    </div>
  );
};

export default Step1AadhaarInput;